import { VALUE_TYPES } from '../data';
import { typeOf } from '../typeOf';
import { cloneBuffer } from './cloneBuffer';
import { cloneRegExp } from './cloneRegExp';
import { cloneSymbol } from './cloneSymbol';

export function cloneShallow<T>(value: T): T {
  switch (typeOf(value)) {
    case VALUE_TYPES.buffer: {
      return cloneBuffer(value as Buffer) as unknown as T;
    }
    case VALUE_TYPES.symbol: {
      return cloneSymbol(value as symbol) as unknown as T;
    }
    case VALUE_TYPES.error: {
      return Object.create(value as Error) as unknown as T;
    }
    case VALUE_TYPES.map: {
      return new Map(value as Map<any, any>) as unknown as T;
    }
    case VALUE_TYPES.set: {
      return new Set(value as Set<any>) as unknown as T;
    }
    case VALUE_TYPES.date: {
      return new Date(value as Date) as unknown as T;
    }
    case VALUE_TYPES.regexp: {
      return cloneRegExp(value as unknown as RegExp) as unknown as T;
    }
  }

  return value;
}
